import { render, staticRenderFns } from "./MediaSearchArchiveMedia.vue?vue&type=template&id=18c4749c"
import script from "./MediaSearchArchiveMedia.vue?vue&type=script&lang=js"
export * from "./MediaSearchArchiveMedia.vue?vue&type=script&lang=js"
import style0 from "./MediaSearchArchiveMedia.vue?vue&type=style&index=0&id=18c4749c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports